import { LoggingService } from 'src/app/core/services/logging.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { UserDetails } from './../../../../shared/models/userDetail.model';
import { ManageUsersService } from './../../services/manage-users.service';
import {
  USER_PROFILE,
  TRAINING,
  AFFILIATION,
  UPLOADS,
  MANAGE_USERS_URL,
  USER_PROFILE_URL,
  NEW_USER_URL,
} from './../../../../shared/constants/constant';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
})
export class UserProfileComponent implements OnInit {
  public MANAGE_USERS_URL;
  public submitUserForm: any;
  public math = Math;
  public tabs = [
    { name: USER_PROFILE, disable: false, url: USER_PROFILE_URL },
    { name: AFFILIATION, disable: false, url: AFFILIATION },
    { name: TRAINING, disable: false, url: TRAINING },
    { name: UPLOADS, disable: false, url: UPLOADS },
  ];
  public selectedUser: any;
  public displayName: string;
  public updatedByObj: any = {};

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loggingService: LoggingService,
    private manageUsersService: ManageUsersService
  ) {
    try {
      this.MANAGE_USERS_URL = this.router.url
        .substr(1, this.router.url.indexOf('/user'))
        .slice(0, -1);
      const users: UserDetails[] = JSON.parse(
        sessionStorage.getItem('ALL_USERS')
      );
      this.route.params.subscribe((params) => {
        const index = users && users.findIndex((x) => x.loginID == params.id);
        if (params.id === NEW_USER_URL) {
          if (
            history &&
            history.state &&
            (history.state.id || history.state.guid)
          ) {
            this.selectedUser = history.state;
            this.displayName = this.selectedUser.displayName;
            this.updateTabs();
          } else {
            this.router.navigateByUrl('/manage-users');
          }
        } else {
          if (users && index > -1) {
            this.selectedUser = users[index];
            this.displayName = users[index].displayName;
          }
        }
      });
      this.manageUsersService.updateUserProfileUpdateStr.subscribe(
        (response) => {
          if (response && response['updatedOn']) {
            this.updatedByObj.updatedOn = response['updatedOn'];
            this.updatedByObj.updatedBy = response['updatedBy'];
          } else {
            this.updatedByObj = {};
          }
        }
      );
      this.manageUsersService.updateTabs.subscribe((response: UserDetails) => {
        this.selectedUser = response;
        this.displayName = response.displayName;
        if (response && response.updatedOn) {
          this.updatedByObj.updatedOn = response.updatedOn;
          this.updatedByObj.updatedBy = response.updatedBy;
        }
        this.updateTabs();
        this.onTabSelection(this.getSelectedTabURL());
      });
    } catch (exp) {
      this.loggingService.logTrace(
        'user-profile.component -> constructor' + exp
      );
    }
  }

  /**
   * @description Update user details tab array based on updatedOn value
   *
   * @param none
   * @memberof UserProfileComponent
   */
  public updateTabs(): void {
    if (this.selectedUser.updatedOn) {
      this.tabs = [
        { name: USER_PROFILE, disable: false, url: USER_PROFILE_URL },
        { name: AFFILIATION, disable: false, url: AFFILIATION },
        { name: TRAINING, disable: false, url: TRAINING },
        { name: UPLOADS, disable: false, url: UPLOADS },
      ];
    } else {
      this.tabs = [
        { name: USER_PROFILE, disable: false, url: USER_PROFILE_URL },
        { name: AFFILIATION, disable: true, url: AFFILIATION },
        { name: TRAINING, disable: true, url: TRAINING },
        { name: UPLOADS, disable: true, url: UPLOADS },
      ];
    }
  }

  ngOnInit(): void {}

  /**
   * @description function use to redirect user to after selecting tab
   *
   * @param {{ url: any; }} tab
   * @memberof UserProfileComponent
   */
  onTabSelection(tab: { url: any }): void {
    try {
      if (
        this.selectedUser &&
        this.selectedUser.loginID &&
        this.router.url.toString().indexOf(NEW_USER_URL) > -1
      ) {
        const url = this.router.url.toString();
        const newUrl = url.replace(
          NEW_USER_URL,
          this.selectedUser.loginID.toString()
        );
        this.router.navigate([newUrl]);
      } else {
        this.router.navigate([tab.url], { relativeTo: this.route });
      }
    } catch (exp) {
      this.loggingService.logTrace(
        'user-profile.component -> onTabSelection' + exp
      );
    }
  }

  /**
   * @description function use for selecting user name from list
   *
   * @return {*}  {string}
   * @memberof UserProfileComponent
   */
  getSelectedTab(): string {
    try {
      const selectedTab = this.tabs.findIndex(
        (x) => this.router.url.indexOf(x.url) > -1
      );
      if (this.tabs[selectedTab]) {
        return this.tabs[selectedTab].name;
      }
      return '';
    } catch (exp) {
      this.loggingService.logTrace(
        'user-profile.component -> constructor' + exp
      );
    }
  }

  /**
   * @description function use for selecting user details from list
   *
   * @return []  [object]
   * @memberof UserProfileComponent
   */
  getSelectedTabURL(): any {
    try {
      const selectedTab = this.tabs.findIndex(
        (x) => this.router.url.indexOf(x.url) > -1
      );
      return this.tabs[selectedTab];
    } catch (exp) {
      this.loggingService.logTrace(
        'user-profile.component -> constructor' + exp
      );
    }
  }
}
